<template>
  <v-container fluid>
    <v-card elevation="0">
      <v-card-title>
        <v-layout row>
          <v-col cols="2">
            Gesamtzeitraum
          </v-col>
          <v-col cols="2">
            <v-menu
              ref="menu"
              v-model="menu.statistic.start"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="statistic.start"
                  label="Startmonat"
                  prepend-icon="mdi-calendar"
                  max-width="290px"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="statistic.start"
                type="month"
                :max="statistic.end"
                no-title
                scrollable
                locale="de"
              />
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-menu
              ref="menu"
              v-model="menu.statistic.end"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="statistic.end"
                  label="Endmonat"
                  prepend-icon="mdi-calendar"
                  max-width="290px"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="statistic.end"
                type="month"
                :min="statistic.start"
                no-title
                scrollable
                locale="de"
              />
            </v-menu>
          </v-col>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-divider class="primary" />
    <template v-for="(abbuchung, index) in abbuchungen">
      <v-card :key="`abbuchung__${index + 1}`" elevation="0">
        <v-card-title>
          <v-layout row>
            <v-col cols="2">
              <v-btn
                v-if="index != 0"
                icon
                color="error"
                @click="deleteTimeframe(index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>{{ index + 1 }}. Zeitraum
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="abbuchung.start"
                :label="`${index + 1}. Startmonat`"
                prepend-icon="mdi-calendar"
                readonly
              />
            </v-col>
            <v-col cols="2">
              <v-menu
                v-model="abbuchung.endmenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="abbuchung.end"
                    :label="`${index + 1}. Endmonat`"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="abbuchung.end"
                  type="month"
                  :min="abbuchung.start"
                  :max="statistic.end"
                  no-title
                  scrollable
                  locale="de"
                />
              </v-menu>
            </v-col>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <v-col cols="2">
              <MoneyInputField
                v-model="abbuchung.server"
                label="Grundrauschen (Server, Gehalt etc.)"
                prefix="-"
                suffix="€/mon"
              />
            </v-col>
            <v-col cols="2">
              <MoneyInputField
                v-model="abbuchung.license"
                label="Kosten NWT - Lizenzen"
                prefix="-"
                suffix="€/mon"
              />
            </v-col>
            <v-col cols="2">
              <MoneyInputField
                v-model="abbuchung.debit"
                label="Verträge NWT - Abbuchung"
                suffix="€/mon"
              />
            </v-col>
            <v-col cols="2">
              <MoneyInputField
                v-model="abbuchung.invoice"
                label="Verträge NWT - Rechnungen"
                suffix="€/mon"
              />
            </v-col>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>
    <v-row>
      <v-col>
        <v-btn
          color="primary"
          :loading="loadingChartData"
          @click="fetchGoogleChartData"
        >
          Statistik generieren
        </v-btn>
      </v-col>
    </v-row>
    <v-layout row justify-center>
      <v-progress-circular
        v-if="loadingChartData"
        indeterminate
        color="primary"
      />
      <GChart
        v-if="googleChart && !loadingChartData"
        :settings="{ packages: ['corechart'], language: 'de'}"
        type="ComboChart"
        :data="googleChart.data"
        :options="googleChart.options"
      />
    </v-layout>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import { GChart } from 'vue-google-charts'
import axios from 'axios'
import MoneyInputField from '@shared/MoneyInputField'
export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: 'Statistik - Kosten, Umsatz und Gewinn',
      }
   },
   components: {
      GChart,
      MoneyInputField,
   },
   layout: (h, page) => h(Layout, [page]),
   props: {},
   data () {
      return {
         googleChart: null,
         menu: {
            statistic: {
               start: false,
               end: false,
            },
         },
         statistic: {
            start: new Date().toISOString().substr(0, 7),
            end: new Date(new Date().setMonth(new Date().getMonth() + 60))
               .toISOString()
               .substr(0, 7),
         },
         loadingChartData: false,
         abbuchungen: [
            {
               start: new Date().toISOString().substr(0, 7),
               end: new Date(new Date().setMonth(new Date().getMonth() + 60))
                  .toISOString()
                  .substr(0, 7),
               server: 0,
               invoice: 0,
               debit: 0,
               license: 0,
            },
         ],
         lastRowDeleted: false,
      }
   },
   watch: {
      abbuchungen: {
         deep: true,
         handler (val, oldVal) {
            val.forEach((timeframe, index) => {
               if (val[index + 1] && timeframe.end !== val[index + 1].start) {
                  val[index + 1].start = new Date(
                     new Date(timeframe.end).setMonth(
                        new Date(timeframe.end).getMonth() + 1
                     )
                  )
                     .toISOString()
                     .substr(0, 7)
               }
            })
            const lastElement = val[val.length - 1]
            if (lastElement.end < this.statistic.end) {
               if (this.lastRowDeleted) {
                  // Watcher fügt sonst wieder eine Zeile hinzu
                  console.log('deleted last element')
                  lastElement.end = this.statistic.end
                  this.lastRowDeleted = false
               } else {
                  this.abbuchungen.push({
                     start: new Date(
                        new Date(lastElement.end).setMonth(
                           new Date(lastElement.end).getMonth() + 1
                        )
                     )
                        .toISOString()
                        .substr(0, 7),
                     end: this.statistic.end,
                     server: 0,
                     invoice: 0,
                     debit: 0,
                     license: 0,
                  })
               }
            }
         },
      },
      'statistic.start': {
         handler (val, oldVal) {
            this.abbuchungen[0].start = val
         },
      },
      'statistic.end': {
         handler (val, oldVal) {
            const lastindex = this.abbuchungen.length - 1
            this.abbuchungen[lastindex].end = val
         },
      },
   },
   created () {},
   methods: {
      fetchGoogleChartData () {
         console.log()
         this.loadingChartData = true
         axios
            .post(
               this.route('statistic.contract.googleChartData', 'contracts'),
               {
                  timeframes: this.abbuchungen,
               }
            )
            .then((response) => {
               this.loadingChartData = false
               this.googleChart = response.data
               console.log(response)
            })
            .catch((error) => {
               this.loadingChartData = false
               console.error(error)
            })
      },
      deleteTimeframe (index) {
         // Watcher fügt sonst wieder Zeile hinzu
         if (index === this.abbuchungen.length - 1) {
            this.lastRowDeleted = true
         }
         this.abbuchungen.splice(index, 1)
      },
   },
}
</script>

<style>
</style>
